var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      class: [
        {
          "box-layout": _vm.boxLayout,
          "collapse-sidebar": _vm.collapseSidebar,
          "rtl-layout": _vm.rtlLayout
        }
      ],
      attrs: { dark: _vm.darkMode, id: "inspire" }
    },
    [_c("router-view"), _vm._v(" "), _c("AppConfirmationDialog")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39336072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39336072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = eilb
// module chunks = 5